export default __webpack_public_path__ + "static/media/classic-cell-culture-solution.8a08cfb3.png";